// Mock data for Pawwprints — pet rescue & fostering platform (Melbourne, VIC)
// This data mirrors the live app and will later be served from the backend.

export const SUBURBS = [
  "Fitzroy",
  "St Kilda",
  "Brunswick",
  "Carlton",
  "Richmond",
  "Melbourne CBD",
  "Footscray",
  "Preston",
];

export const HERO = {
  image: "/img/lucky-hero.webp",
  badge: "IN MEMORY OF LUCKY",
  title: "Every stray deserves a home.",
  subtitle: "Foster a paw, save a life.",
};

export const MEMORIAL = {
  image: "/img/lucky-memorial.webp",
  heading: "IN LOVING MEMORY — LUCKY'S LAST SUNSET",
  name: "Lucky",
  posted_by: "The Pawwprints family",
  text: "For 14 years strong, the best dog I could have ever asked for. Never forgotten. Will miss you forever mate. Rest easy ❤️",
  candles: 128,
  cta: "Light a candle on the Memorial Wall",
};

export const STATS = [
  { value: 5, label: "Looking for\na home", color: "orange" },
  { value: 1, label: "Safely in\nfoster care", color: "green" },
  { value: 6, label: "Total\nrescues", color: "navy" },
];

export const FEATURE_CARDS = [
  {
    id: "map",
    kicker: "EXPLORE BY LOCATION",
    title: "Rescues near you",
    subtitle: "Browse rescued animals in your area looking for a home",
    emoji: "🐾",
    accent: "#f2683f",
    action: "navigate:/rescues",
    image:
      "https://images.pexels.com/photos/1766226/pexels-photo-1766226.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=940",
  },
  {
    id: "logstray",
    kicker: "SPOT A STRAY? LOG AWAY! 👀✍️📝",
    title: "Report a stray near you",
    subtitle: "Opens the live Australia map — strays, injured & sightings in real time.",
    emoji: "👀",
    accent: "#3F72C0",
    dark: true,
    action: "navigate:/map",
    image:
      "https://images.unsplash.com/photo-1683576221736-ab17ac9ffe61?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxhdXN0cmFsaWElMjBtYXAlMjBsb2NhdGlvbiUyMHBpbnN8ZW58MHx8fHwxNzg0NjY3NTcwfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "lostpets",
    kicker: "🆘 REUNITE A MISSING PET",
    title: "Lost Your Pet?",
    subtitle: "Lost or found a pet? Post it here — reunions happen fast.",
    emoji: "🆘",
    accent: "#4FB0AE",
    dark: true,
    action: "navigate:/lost",
    image:
      "https://images.unsplash.com/photo-1557495235-340eb888a9fb?crop=entropy&cs=srgb&fm=jpg&w=940&q=80",
  },
  {
    id: "hotspots",
    kicker: "🔥 HOT SPOTS · ALL AUS STATES",
    title: "High-activity stray zones",
    subtitle: "Live map · 32+ zones tracked from Melbourne to Darwin.",
    emoji: "🔥",
    accent: "#D76A6A",
    dark: true,
    action: "navigate:/hotspots",
    image:
      "https://images.unsplash.com/photo-1584291527905-f930791fb1ce?crop=entropy&cs=srgb&fm=jpg&w=940&q=80",
  },
  {
    id: "scanner",
    kicker: "AI BREED SCANNER 📸",
    title: "Snap a stray · ID the breed",
    subtitle: "Gemini Vision AI · results in seconds · +25 pts.",
    emoji: "📸",
    accent: "#81B29A",
    dark: true,
    action: "navigate:/breed-scan",
    image:
      "https://images.unsplash.com/photo-1594920447494-5b731d99fa8b?crop=entropy&cs=srgb&fm=jpg&w=940&q=80",
  },
  {
    id: "walk",
    kicker: "🐕 WALK FOR REWARDS",
    title: "Walk your dog · earn points",
    subtitle: "Verify with a photo, then our step counter turns walks into loyalty points & rewards!",
    emoji: "🐕",
    accent: "#3FA796",
    dark: true,
    action: "navigate:/walk",
    image:
      "https://images.unsplash.com/photo-1530700131180-d43d9b8cc41f?crop=entropy&cs=srgb&fm=jpg&w=940&q=80",
  },
  {
    id: "community",
    kicker: "📸 POST YOUR PET",
    title: "Share your pet · join the Wall of Fame!",
    subtitle: "Photos & videos · free like counter · top posts rise 🔥",
    emoji: "🐾",
    accent: "#274a86",
    dark: true,
    action: "navigate:/community",
    image:
      "https://images.unsplash.com/photo-1774675662972-46f53ccf01b9?crop=entropy&cs=srgb&fm=jpg&w=940&q=80",
  },
  {
    id: "sitters",
    kicker: "DOG SITTERS 🏡",
    title: "Trusted sitters near you",
    subtitle: "In-home or at theirs · $35-$85/day · vetted.",
    emoji: "🏡",
    accent: "#E07A5F",
    dark: true,
    action: "navigate:/sitters",
    image:
      "https://images.unsplash.com/photo-1741872329231-c31765f16ee6?crop=entropy&cs=srgb&fm=jpg&w=940&q=80",
  },
  {
    id: "rewards",
    kicker: "PAWWS REWARDS 🏆",
    title: "Earn points · Save lives",
    subtitle: "+25 pts per stray reported · +50 per sighting · unlock rewards.",
    emoji: "🏆",
    accent: "#F2CC8F",
    dark: false,
    action: "navigate:/rewards",
    image:
      "https://images.unsplash.com/photo-1697131716581-2f0d3050bac5?crop=entropy&cs=srgb&fm=jpg&w=940&q=80",
  },
  {
    id: "donate",
    kicker: "SUPPORT THE CAUSE",
    title: "Help fund every rescue 💙",
    subtitle: "$5 covers a vet visit co-pay. $50 saves a life.",
    emoji: "💙",
    accent: "#7EC0E8",
    dark: true,
    action: "modal:donate",
    image:
      "https://images.unsplash.com/photo-1770836037793-95bdbf190f71?crop=entropy&cs=srgb&fm=jpg&w=940&q=80",
  },
  {
    id: "memorial",
    kicker: "❤️ R.I.P. — IN LOVING MEMORY 🕊️",
    title: "Never forgotten",
    subtitle: "Post a tribute · light a candle · keep them close.",
    emoji: "🕊️",
    accent: "#1B2A4E",
    dark: true,
    action: "navigate:/memorials",
    image:
      "https://images.unsplash.com/photo-1692866999796-bb538d3f9e92?crop=entropy&cs=srgb&fm=jpg&w=940&q=80",
  },
];

export const RESCUES = [
  {
    id: "pip",
    name: "Ghost",
    species: "other",
    speciesEmoji: "🐾",
    breed: "Domestic Rabbit",
    suburb: "Melbourne CBD",
    description:
      "Lop-eared rabbit found dumped at Queen Victoria Market. Litter trained.",
    fee: "Free • $30 fee",
    status: "needs_home",
    urgent: true,
    vet: false,
    image:
      "https://images.unsplash.com/photo-1585110396000-c9ffd4e4b308?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "jet",
    name: "Jet",
    species: "other",
    speciesEmoji: "🐾",
    breed: "Domestic Rabbit",
    suburb: "Footscray",
    description:
      "Sleek black bunny surrendered when his family moved overseas. Calm, gentle and litter trained.",
    fee: "Free • $30 fee",
    status: "needs_home",
    urgent: false,
    vet: false,
    image:
      "https://static.prod-images.emergentagent.com/jobs/2c6250c5-ecc3-4f73-bc7f-3a19c98d6394/images/75286b7ce3a1850e94377cb82c3264235ac4208b0b0b83f184c2446aaed8aed3.jpeg",
  },
  {
    id: "pepper-salt",
    name: "Pepper & Salt",
    species: "dog",
    speciesEmoji: "🐶",
    breed: "Kelpie mix (bonded pair)",
    suburb: "St Kilda",
    description:
      "Two bonded dogs found together in St Kilda. Must stay as a pair. Very sweet.",
    fee: "Free • $75 fee",
    status: "needs_home",
    urgent: false,
    vet: false,
    image:
      "https://images.unsplash.com/photo-1765571394628-eeae22f238f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxzdHJheSUyMGRvZyUyMHBvcnRyYWl0fGVufDB8fHx8MTc3NzgwODIzOHww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "luna",
    name: "Luna",
    species: "cat",
    speciesEmoji: "🐱",
    breed: "Domestic Shorthair",
    suburb: "Brunswick",
    description:
      "Gorgeous grey tabby with striking green eyes. Found in Brunswick, very affectionate.",
    fee: "Free • $50 fee",
    status: "needs_home",
    urgent: false,
    vet: false,
    image:
      "https://images.unsplash.com/photo-1702914954859-f037fc75b760?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxjdXRlJTIwY2F0JTIwcG9ydHJhaXR8ZW58MHx8fHwxNzc3ODA4MjM4fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "scout",
    name: "Scout",
    species: "dog",
    speciesEmoji: "🐶",
    breed: "Border Collie",
    suburb: "Carlton",
    description:
      "Energetic young boy found near Carlton Gardens. Limping on rear left leg - needs vet check ASAP.",
    fee: "Free to good home",
    status: "needs_home",
    urgent: false,
    vet: true,
    image:
      "https://images.unsplash.com/photo-1587300003388-59208cc962cb?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "mochi",
    name: "Mochi",
    species: "cat",
    speciesEmoji: "🐱",
    breed: "Domestic Shorthair",
    suburb: "Richmond",
    description:
      "Happy, smiley boy found in Richmond. Loves cuddles, laps and sunny windows.",
    fee: "Free • $50 fee",
    status: "fostered",
    urgent: false,
    vet: false,
    image:
      "https://images.unsplash.com/photo-1543852786-1cf6624b9987?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxoYXBweSUyMGNhdCUyMGZhY2UlMjBsb29raW5nJTIwYXQlMjBjYW1lcmF8ZW58MHx8fHwxNzg1MDg5NjI0fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "biscuit",
    name: "Biscuit",
    species: "dog",
    speciesEmoji: "🐶",
    breed: "Staffy cross",
    suburb: "Fitzroy",
    description:
      "Friendly brown-and-white boy found near Edinburgh Gardens. Great with kids, loves pats.",
    fee: "Free • $75 fee",
    status: "needs_home",
    urgent: false,
    vet: false,
    image:
      "https://images.unsplash.com/photo-1774979301021-1531dc81ed59?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwyfHxzdHJheSUyMGRvZyUyMHBvcnRyYWl0fGVufDB8fHx8MTc3NzgwODIzOHww&ixlib=rb-4.1.0&q=85",
  },
];

export const CARERS = [
  {
    id: "james-chen",
    name: "James Chen",
    suburb: "St Kilda",
    capacity: 3,
    bio: "Vet nurse. Can handle sick or injured animals short-term.",
    address: "112 Acland St, St Kilda VIC 3182",
    phone: "0400 111 222",
    email: "james.chen@example.com",
  },
  {
    id: "priya-nair",
    name: "Priya Nair",
    suburb: "Brunswick",
    capacity: 1,
    bio: "Cat specialist. Quiet home, indoor only.",
    address: "7 Sydney Rd, Brunswick VIC 3056",
    phone: "0400 333 444",
    email: "priya.nair@example.com",
  },
  {
    id: "sarah-mitchell",
    name: "Sarah Mitchell",
    suburb: "Fitzroy",
    capacity: 2,
    bio: "Long-time rescuer with fenced backyard. Dogs welcome.",
    address: "24 Brunswick St, Fitzroy VIC 3065",
    phone: "0400 555 666",
    email: "sarah.mitchell@example.com",
  },
];

export const LOST_PETS = [
  {
    id: "bella",
    name: "Bella",
    breed: "Golden Retriever",
    lastSeen: "Carlton 3053",
    status: "missing",
    reward: "$200 reward",
    description:
      "Sweet golden retriever, very friendly. Wearing pink collar with bell. Microchipped.",
    microchip: "990012345678901",
    owner: "Emma Wilson",
    phone: "0400 777 888",
    email: "emma.wilson@example.com",
    image:
      "https://images.unsplash.com/photo-1633722715463-d30f4f325e24?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "whiskers",
    name: "Whiskers",
    breed: "Tabby cat",
    lastSeen: "Richmond 3121",
    status: "missing",
    reward: "$100 reward",
    description:
      "Orange tabby with white chest. Indoor cat, escaped through window. Very shy.",
    microchip: null,
    owner: "David Park",
    phone: "0400 999 000",
    email: "david.park@example.com",
    image:
      "https://images.unsplash.com/photo-1783597941683-3e8460e0d241?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxnaW5nZXIlMjB0YWJieSUyMGNhdCUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NTA4OTQzOXww&ixlib=rb-4.1.0&q=85",
  },
];

// Map markers — Melbourne & surrounds
export const MAP_MARKERS = [
  { id: "m1", type: "stray", emoji: "🐕", label: "Stray dog · Fitzroy", lat: -37.7963, lng: 144.9789 },
  { id: "m2", type: "stray", emoji: "🐈", label: "Stray cat · Brunswick", lat: -37.7667, lng: 144.9598 },
  { id: "m3", type: "stray", emoji: "🐕", label: "Stray dog · Carlton", lat: -37.8001, lng: 144.9674 },
  { id: "m4", type: "lost", emoji: "🐶", label: "Lost: Bella · Carlton", lat: -37.7845, lng: 144.9689 },
  { id: "m5", type: "lost", emoji: "🐱", label: "Lost: Whiskers · Richmond", lat: -37.8226, lng: 144.9987 },
  { id: "m6", type: "sighting", emoji: "👀", label: "Sighting · St Kilda", lat: -37.8677, lng: 144.9811 },
  { id: "m7", type: "carer", emoji: "🏠", label: "Carer · James Chen", lat: -37.8642, lng: 144.9789 },
  { id: "m8", type: "carer", emoji: "🏠", label: "Carer · Priya Nair", lat: -37.7681, lng: 144.9605 },
  { id: "m9", type: "carer", emoji: "🏠", label: "Carer · Sarah Mitchell", lat: -37.7981, lng: 144.9789 },
];

export const FOUNDER = {
  name: "Joel Thomas",
  roles: [
    "Solo Founder / Owner / CEO",
    "Technical + Design Director / CTO",
    "App & Website Creator",
  ],
  website: "pawwprints.com.au",
  phone: "0400 009 372 (Melb, VIC)",
  emails: ["pawwprintsinfo@gmail.com"],
};

export const REWARDS_TIERS = [
  { key: "bronze", title: "Bronze Paw", pts: 0, color: "#B87333", emoji: "🥉", perks: ["Welcome badge", "Access to Pawws Club"] },
  { key: "silver", title: "Silver Paw", pts: 1000, color: "#9CA3AF", emoji: "🥈", perks: ["Sticker set", "Profile badge"] },
  { key: "gold", title: "Gold Paw", pts: 2500, color: "#E4A93A", emoji: "🥇", perks: ["5% store discount", "Priority listings"] },
  { key: "emerald", title: "Emerald Paw", pts: 4500, color: "#10B981", emoji: "💚", perks: ["10% store discount", "Early access to drops"] },
  { key: "platinum", title: "Platinum Paw", pts: 7000, color: "#64748B", emoji: "🔗", perks: ["15% store discount", "Exclusive merch"] },
  { key: "diamond", title: "Diamond Paw", pts: 10000, color: "#38BDF8", emoji: "💎", perks: ["20% store discount", "Top Helper spotlight", "VIP event invites"] },
];

export const DONATE_AMOUNTS = [5, 15, 50, 100];

// Real Australian animal charities & rescues donors can support
export const CHARITIES = [
  { id: "general", name: "Pawwprints Rescue Fund", focus: "Our own vet care, foster & reunion fund", url: "" },
  { id: "rspca", name: "RSPCA Australia", focus: "National animal welfare & cruelty rescue", url: "https://www.rspca.org.au/" },
  { id: "lortsmith", name: "Lort Smith Animal Hospital", focus: "Melbourne — vet care for pets in need", url: "https://www.lortsmith.com/" },
  { id: "lostdogs", name: "The Lost Dogs' Home", focus: "Melbourne — shelter, rescue & reunion", url: "https://dogshome.com/" },
  { id: "petrescue", name: "PetRescue", focus: "National — connecting rescues & adopters", url: "https://www.petrescue.com.au/" },
  { id: "animalaid", name: "Animal Aid (Victoria)", focus: "Coldstream — shelter, foster & vet clinic", url: "https://www.animalaid.org.au/" },
  { id: "scars", name: "Second Chance Animal Rescue", focus: "Victoria — rescue, rehome & community vet", url: "https://scarinc.org.au/" },
  { id: "edgars", name: "Edgar's Mission", focus: "Farm animal sanctuary, VIC", url: "https://www.edgarsmission.org.au/" },
  { id: "vfc", name: "Vets for Compassion", focus: "Wildlife & rescue emergency vet care", url: "https://vetsforcompassion.org/" },
  { id: "saveadog", name: "Save-A-Dog Scheme", focus: "Melbourne — dog & cat rescue", url: "https://saveadog.org.au/" },
  { id: "greyhound", name: "Greyhound Rescue", focus: "Rescue & rehome ex-racing greyhounds", url: "https://greyhoundrescue.com.au/" },
  { id: "pitp", name: "Pets in the Park", focus: "Vet care for pets of people doing it tough", url: "https://petsinthepark.org.au/" },
  { id: "zoosvic", name: "Zoos Victoria — Wildlife", focus: "Native wildlife conservation & rescue", url: "https://www.zoo.org.au/" },
];

// Major AU vet options for account preference
export const VETS = [
  { id: "greencross", name: "Greencross Vets", url: "https://www.greencrossvets.com.au/find-a-vet/" },
  { id: "petstock", name: "Petstock Vet", url: "https://www.petstock.com.au/vet" },
  { id: "lortsmith", name: "Lort Smith Animal Hospital", url: "https://www.lortsmith.com/" },
  { id: "aec", name: "Animal Emergency Centre", url: "https://animalemergencycentre.com.au/" },
  { id: "vsg", name: "Veterinary Specialists (VSS/MVSC)", url: "https://www.google.com/search?q=veterinary+specialist+centre+near+me" },
  { id: "other", name: "My local vet (search)", url: "https://www.google.com/search?q=vet+near+me" },
];

// Main VIC councils — action opens their official pet-registration page (Google-verified redirect keeps links live)
export const COUNCILS = [
  "City of Melbourne", "Melton City Council", "Brimbank City Council", "Wyndham City Council",
  "Hume City Council", "City of Casey", "City of Whittlesea", "City of Greater Geelong",
  "City of Yarra", "Merri-bek City Council", "City of Darebin", "City of Boroondara",
  "City of Monash", "City of Kingston", "Maribyrnong City Council", "Hobsons Bay City Council",
];
